module.exports = "/fonts/ProductSans-Regular.woff?0a489488ab3cb2eb11f9f6d59e1fb995";